'use strict' ;
angular.module("Khayrokom").config(['$translateProvider', function($translateProvider) {
    $translateProvider.translations("ar", {// arabic
        ERROR500:"حدث عطل فني ",
        SUCCESS:"تم تحميل البيانات بنجاح",
        GENERAL_ERROR:"لم يتم تحميل البيانات",
        ERROR401:"الكود الذي تم إدخاله غير صالح",
        EMPTY_EMAIL:"أدخل البريد الإلكتروني",
        EMPTY_MESSAGE:"أدخل الرسالة ",
        EMPTY_NAME:"أدخل الاسم بالكامل",
        EMPTY_COMMENT:"اكتب التعليق",
        ERROR_EMAIL:"البريد الإلكتروني غير صحيح",
        EMPTY_CODE:"أدخل الكود"
    });
    $translateProvider.translations("en", {// english
        ERROR500:"A Technical Error happened",
        SUCCESS:"The data has been loaded successfully",
        GENERAL_ERROR:"the data hasn't be loaded",
        ERROR401:"The code that has been entered is not valid",
        EMPTY_EMAIL:"Enter Email",
        EMPTY_MESSAGE:"Enter Message",
        EMPTY_NAME:"Enter Name",
        EMPTY_COMMENT:"Type Comment",
        ERROR_EMAIL:"Invalid Email",
        EMPTY_CODE:"Type Code"
    });
    $translateProvider.preferredLanguage("ar");
    $translateProvider.useSanitizeValueStrategy('escape');
}]);


// WEBPACK FOOTER //
// ./js/app/translateNotification.js